// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2GbdE","subheader":"ReorderModal_subheader__1ec29","listWrap":"ReorderModal_listWrap__2H7GV"};